var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<integrations></integrations><div ng-if=\"$root.GROOVE_WIDGET\" groove></div><div ng-if=\"$root.TAPFILIATE_ENABLED\" tapfiliate></div><div ui-view=\"\"></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/index.jade
// module id = 555
// module chunks = 0